import { createContext } from "react";

export const SearchContext = createContext({
  search: { enabled: false, placeholder: "", onSearch: () => {} },
  setSearch: () => {},
});

export const SearchValueContext = createContext("");

export const SearchSetValueContext = createContext(() => {});
